import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import Availability from '../Basepage/parts/Availability';
import { PageMode } from '../Basepage/parts/Definitions';
import ProductCarousel from '../Basepage/parts/ProductCarousel';
import ImageContainer from './Parts/ImageContainer';
import SubTitle from './Parts/SubTitle';
import SozialShare from './Parts/SozialShare';
import DescriptionContainer from './Parts/DescriptionContainer';
import JSONLD_PD from './Parts/JSONLD_PD';
import FB_pixel from './Parts/FB_pixel';
import GoogleAnalytics from './Parts/GoogleAnalytics';
import WebgainsDetailsTag from './Parts/WebgainsDetailsTag';

import imgPOD from './Parts/images/icon-print-on-demand.svg';
import imgPreOrder from './Parts/images/icon-vorbestellen.svg';

import './index.scss';
import { getObjectFromForm, replaceAllComplex } from '../../../../mol_function';
import VariantsManager from './Parts/VariantsManager';
import MolLink from '../Basepage/parts/Menu/MolLink';
import { ConsentEnum, hasConsent } from '../Basepage/parts/CookieManager';

import $ from 'jquery';
import Ampel, { AmpelDataItem } from './Parts/Ampel';
import DescriptionContainerElement from './Parts/DescriptionContainerElement';

interface ProductInfoPageState extends BasePageState {
  preissmode: 'libri' | 'schnell' | 'standart';
}

export interface preisObjectType {
  lieferbar: boolean;
  options: {
    Einkaufspreis: number;
    Rabatt: number;
    lz: number;
    mode: string;
    mol_lieferant: number;
  }[];
}

interface ProductInfoPageModel {
  libriProduct: any;
  rabat: { header: string; value: string }[][];
  preisObject: preisObjectType;
  ampel?: AmpelDataItem[];

  images: string[];
  imagesSmall: string[];
  productsDeliveryTime: number;
  domainPrefix: string;
  cutOff: any;
  isNewProduct: boolean;
  isShipingFree: boolean;
  isPackageSend: boolean;

  productPrice: string;
  productsId: number;

  products_quantity: number;
  products_quantity_order_max: number;

  productsDescription: string;

  hasProduct: boolean;
  securityToken: string;

  apd: ProductCarouselModel[];
  recent_products?: ProductCarouselModel[];

  title: string;
  categorie: string;
  link: string;

  attribute: [{ name: string; seperator: string | null; value: string }];

  reviews: ReviewDetails[];
  media: any;
  ean: string;
  release_date: string | null;
  pod_shipingTime: number | undefined;
}

export default class ProductInfoPage extends Basepage<
  ProductInfoPageState,
  ProductInfoPageModel
> {
  pageHeaderGetter(): string | null {
    let noIndex = '<meta name="robots" content="noindex">';
    let myLink = this.getCanonicalLink();

    let canonicalLink = '<link rel="canonical" href="' + myLink + '" />';

    let omgImage = '';
    for (
      let i = 0;
      this.body.images != null && i < this.body.images.length;
      i++
    )
      omgImage +=
        '<meta property="og:image" content="https://media.moluna.de/images/bilder/' +
        this.body.images[i] +
        '">';

    return noIndex + canonicalLink + omgImage;
  }
  getCanonicalLink(): string | null {
    return this.body.link;
  }

  pageTitleGetter() {
    if (this.body.hasProduct)
      return (
        this.body.title +
        ' [' +
        this.body.productsId +
        '] - ' +
        this.body.productPrice
      );
    else {
      return '';
    }
  }

  getRightBreadCrumbParts(): JSX.Element {
    /* TODO: Create artikel-bewerten*/
    if (false && this.state.hasApiData) {
      return (
        <a
          className="artikel-bewerten"
          href={
            '/index.php?main_page=product_reviews_write&products_id=' +
            this.body.productsId +
            '&number_of_uploads=0'
          }
          title="Artikel bewerten"
        >
          Artikel bewerten
        </a>
      );
    } else return <></>;
  }
  getType(): string {
    return 'ProductInfoPage';
  }
  getBreadCrumb() {
    if (this.state.apiData)
      return (
        <React.Fragment>
          <MolLink
            href={
              this.state.renderingDomain +
              '/Kategorie/' +
              this.body.categorie +
              '/s/'
            }
            to={'/search_page/?fqZZZKategorie=' + this.body.categorie}
          >
            {this.body.categorie}
          </MolLink>
          <span>
            {replaceAllComplex(this.body.title, [
              { s: "\\'", r: "'" },
              { s: '\\"', r: '"' },
            ])}
          </span>
        </React.Fragment>
      );
    else return <div>Laden</div>;
  }
  initState(base: BasePageState): ProductInfoPageState {
    let dummy: any = this.props;

    let newState: ProductInfoPageState = {
      ...base,
      preissmode: 'standart',
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    let anyProps: any = this.props;

    return (
      this.state.apiBase +
      '/ProductInfo.php?products_id=' +
      anyProps.match.params.products_id
    );
  }

  releaseOneCommand(): void {}

  childDidMount(): void {
    if (this.state.hasApiData) {
      let anyProps: any = this.props;
      if (this.body.libriProduct) {
        this.setState({ preissmode: 'libri' });
      } else {
        switch (this.body.shopingMode) {
          case 'schnell':
            this.setState({ preissmode: 'schnell' });
            break;
          case 'standart':
          default:
            this.setState({ preissmode: 'standart' });
            break;
        }
      }

      let apdUrl =
        this.state.apiBase +
        '/index.php?frame=api&main_page=product_info_apd&products_id=' +
        anyProps.match.params.products_id;
      //TODO: Anliche Produkte
      //debugger;
      /*
    fetch(apdUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let tdata = data;
        let curentState = this.state.apiData;

        let oldApd = curentState.body.apd;
        let nedReload = false;

        if (JSON.stringify(oldApd) != JSON.stringify(data.body.apd)) {
          curentState.body.apd = data.body.apd;
          nedReload = true;
        }

        if (
          nedReload &&
          this.getType() == 'ProductInfoPage' &&
          this.state.hasApiData
        ) {
          this.setState({ apiData: curentState });
        }
      });
      */
    }
  }

  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}

  modeToText() {
    switch (this.state.preissmode) {
      case 'standart':
        return 'standart';
      case 'schnell':
        return 'schnell';
      case 'libri':
        return 'libri';
    }
    if (this.state.preissmode == 0) {
      return 'standart';
    }
  }

  renderChild() {
    let productsDeliveryDate: Date | undefined = undefined;
    if (this.body.release_date != null) {
      productsDeliveryDate = new Date(Date.parse(this.body.release_date));
    }

    this.state.preissmode;
    let modeTranslate = this.modeToText();

    if (this.body.libriProduct) {
      modeTranslate = 'libri';
    }
    let rabatArray = this.body?.rabat ?? [];

    let rabatHeader = rabatArray[modeTranslate] ?? [];

    let preisObject = this.body.preisObject;

    let rabatKeys = Object.keys(rabatArray);
    if (this.body.libriProduct && rabatKeys.includes('schnell')) {
      delete rabatArray['schnell'];
    }

    if (this.body.libriProduct) {
      modeTranslate = 'libri';
      delete rabatArray['standart'];
    }

    rabatKeys = Object.keys(rabatArray);

    return (
      <div id="productInfo">
        {this.body.hasProduct ? (
          <form
            /*
            action={
              this.state.renderingDomain +
              '/index.php?main_page=product_info&products_id=' +
              this.body.productsId +
              '&number_of_uploads=0&action=add_product'
            }
            method="POST"
            encType="multipart/form-data"
            */
            onSubmit={(event) => {
              event.preventDefault();
              let forwardToCheckOut = false;

              let submitterClass = '';

              let nativeEvent: any = event.nativeEvent;

              if (
                nativeEvent != null &&
                nativeEvent.submitter != null &&
                nativeEvent.submitter.className != null
              ) {
                submitterClass = nativeEvent.submitter.className;

                if (submitterClass == 'button_in_checkout')
                  forwardToCheckOut = true;
              }

              let result: any = getObjectFromForm($(event.target));
              let item = [
                {
                  product: +result.products_id,
                  quantity: +result.cart_quantity,
                  mode: result.mode,
                },
              ];

              if (forwardToCheckOut) {
                item.push({ subCommand: 'navigateToCheckout' });
              }

              let itemJson = JSON.stringify(item);

              let targetUrl = '/shopping_cart/?add=' + encodeURI(itemJson);

              window.historyHelper.memory.push(targetUrl);
            }}
          >
            <input
              type="hidden"
              name="securityToken"
              value={this.body.securityToken}
            />
            <ImageContainer
              hasProduct={this.body.hasProduct}
              images={this.body.images}
              imagesSmall={this.body.imagesSmall}
              domainPrefix={this.state.renderingDomain}
              isNewProduct={this.body.isNewProduct}
              isShipingFree={this.body.isShipingFree}
              isPackageSend={this.body.isPackageSend}
              hasLeseprobe={
                this.body.media != undefined &&
                Object.keys(this.body.media).length > 0
              }
              title={this.body.title}
              height={this.state.mode != PageMode.Mobile ? 450 : 200}
              showDots={this.state.mode != PageMode.Mobile}
            ></ImageContainer>
            <div id="p-right">
              <div className="p-right_in">
                {this.state.mode != PageMode.Mobile ? (
                  <div id="categoryIcon" className="categoryIcon">
                    <a
                      href={
                        this.state.renderingDomain +
                        '/Kategorie/' +
                        this.body.categorie +
                        '/s/'
                      }
                    >
                      {this.body.categorie}
                    </a>
                  </div>
                ) : null}

                <h1 id="productName" className="productGeneral">
                  <SubTitle
                    category={this.body.categorie}
                    attribute={this.body.attribute}
                    domainPrefix={this.state.renderingDomain}
                  ></SubTitle>
                </h1>
                {this.body.productsDeliveryTime == 994 ? (
                  <img
                    src={imgPOD}
                    style={{
                      width: '200px',
                    }}
                    alt="Print on Demand - Dieser Artikel wird für Sie gedruckt!"
                    title="Print on Demand - Dieser Artikel wird für Sie gedruckt!"
                  ></img>
                ) : null}
                {this.body.productsDeliveryTime == 998 ? (
                  <img
                    src={imgPreOrder}
                    style={{
                      width: '200px',
                    }}
                    alt="jetzt Vorbestellen - Dieser Artikel erscheint erst noch, wir liefern Ihn zum Erscheinungstermin!"
                    title="jetzt Vorbestellen - Dieser Artikel erscheint erst noch, wir liefern Ihn zum Erscheinungstermin!"
                  ></img>
                ) : null}
                {this.state.hasCookie ? (
                  <>
                    {/*
                    <div id="productPricesContainer">
                      <h2 id="productPrices" className="productGeneral">
                        {this.body.productPrice}
                      </h2>
                      <div className="taxAddon">
                        zzgl. MwSt. ·{' '}
                        {this.body.isShipingFree ? (
                          'Portofrei'
                        ) : (
                          <a
                            href={this.state.renderingDomain + '/versandkosten'}
                            target="_blank"
                          >
                            zzgl. Versand
                          </a>
                        )}
                      </div>
                    </div>
                     */}

                    <div id="rabatContainer">
                      <table id="rabat">
                        <tr className="row header" key="rabat_header">
                          {rabatHeader.map((item, index) => {
                            return (
                              <th
                                className="cell header"
                                key={'rabat' + '_' + 'header' + '_' + index}
                              >
                                {item.header}
                              </th>
                            );
                          })}
                          {rabatKeys.length > 1 ? (
                            <>
                              <th>Bezugsvariante</th>
                            </>
                          ) : null}
                        </tr>

                        {rabatKeys.map((k_item, k_index) => {
                          return (
                            <tr className="row">
                              {(rabatArray[k_item] ?? []).map((item, index) => {
                                let dynamicParams: any = {};

                                if (k_index == 0 && index == 0) {
                                  dynamicParams.rowSpan = rabatKeys.length;
                                }

                                if (index != 0 || (index == 0 && k_index == 0))
                                  return (
                                    <td
                                      className="cell"
                                      {...dynamicParams}
                                      key={
                                        'rabat' +
                                        k_item +
                                        '_' +
                                        'value' +
                                        '_' +
                                        index
                                      }
                                    >
                                      {item.value}
                                    </td>
                                  );
                              })}
                              <td
                                style={{
                                  display:
                                    rabatKeys.length > 1
                                      ? 'table-cell'
                                      : 'none',
                                }}
                              >
                                <input
                                  type="radio"
                                  name="mode"
                                  value={k_item}
                                  checked={this.modeToText() == k_item}
                                  onClick={() => {
                                    this.setState({ preissmode: k_item });
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </table>

                      {this.state.isBuchhandler ? (
                        <>
                          <br />
                          <span className="taxAddon">
                            Diese Preise richten sich ausschließlich an
                            Buchhändler.
                          </span>
                        </>
                      ) : null}
                    </div>
                  </>
                ) : null}

                <br className="clearBoth" />

                <div id="cartAdd">
                  {/* 
                  <Availability
                    productsDeliveryTime={this.body.productsDeliveryTime}
                    cutOff={this.body.cutOff}
                    domainPrefix={this.state.renderingDomain}
                    productsDeliveryDate={productsDeliveryDate}
                    productsDeliveryTimeOverride={this.body.pod_shipingTime}
                  />
                  */}

                  {/*TODO: Wrap in cart */}
                  <div id="wrap_incart"></div>
                </div>
              </div>
              <div id="incart_button">
                {!this.body.libriProduct ? (
                  <>
                    {rabatKeys.length > 1 ? (
                      <>
                        {this.modeToText() == 'schnell' ? (
                          <>
                            Dieser Artikel wird <b>schnellstmöglich</b> für Sie
                            besorgt, wollen Sie Ihn günstiger haben, wählen Sie
                            bitte die andere Bezugsvariante aus.
                            <br />
                          </>
                        ) : (
                          <>
                            Dieser Artikel wird <b>günstigst</b> für Sie
                            besorgt, wollen Sie Ihn schneller haben, wählen Sie
                            bitte die andere Bezugsvariante aus.
                            <br />
                          </>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <input type="hidden" name="mode" value="libri"></input>
                )}
                <br />
                <input
                  type="hidden"
                  name="products_id"
                  value={this.body.productsId}
                ></input>
                {this.state.hasCookie ? (
                  this.body.productsDeliveryTime < 999 ? (
                    <>
                      <div className="qty_button">
                        {this.state.mode != PageMode.Mobile ? (
                          <span className="qty_txt">Menge: </span>
                        ) : null}
                        <input
                          className="cart_quantity"
                          type="text"
                          name="cart_quantity"
                          defaultValue="1"
                          maxLength={3}
                          size={3}
                        />
                      </div>
                      <div>
                        <a
                          title={
                            this.body.title +
                            ' ' +
                            this.body.categorie +
                            ' in den Warenkorb'
                          }
                          rel="nofollow"
                        >
                          <input
                            className="button_in_cart"
                            type="submit"
                            value="in den Warenkorb"
                          />
                        </a>

                        <a
                          href={
                            this.state.renderingDomain +
                            '/index.php?main_page=product_info&products_id=' +
                            this.body.productsId +
                            '&quick_checkout=klarna'
                          }
                          title={
                            this.body.title +
                            ' ' +
                            this.body.categorie +
                            ' jetzt kaufen'
                          }
                          rel="nofollow"
                        >
                          <input
                            className="button_in_checkout"
                            type="submit"
                            value="zur Kasse gehen"
                          />
                        </a>
                      </div>
                    </>
                  ) : (
                    <span
                      style={{
                        color: '#C20F0D',
                        fontWeight: 'bold',
                        fontSize: 'x-large',
                      }}
                    >
                      Zur Zeit nicht bestellbar.
                    </span>
                  )
                ) : (
                  <strong style={{ color: '#C20F0D' }}>
                    Vielen Dank für Ihr Interesse an diesem Produkt. Leider
                    können wir keine Bestellung durchführen ohne das Sie die
                    Cookies akzeptieren. Bitte wählen Sie unten im Banner den
                    entsprechenden Cookie aus. Ansonsten rufen Sie uns gerne an,
                    wir nehmen Ihre Bestellung dann gerne telefonisch auf.
                  </strong>
                )}
              </div>

              <VariantsManager
                variants={this.body.variants}
                thisProductId={this.body.productsId}
                productTittle={this.body.title}
              />
            </div>

            <br className="clearBoth" />

            <div id="cart">
              <DescriptionContainer
                attribute={this.body.attribute}
                productsId={this.body.productsId}
                productsDescription={this.body.productsDescription}
                domainPrefix={this.state.renderingDomain}
                category={this.body.categorie}
                title={this.body.title}
                reviews={this.body.reviews}
                media={this.body.media}
                ean={this.body.ean}
              />
              {this.state.isBuchhandler ? (
                <>
                  {!this.body.libriProduct &&
                  this.body.ampel != undefined &&
                  this.body.ampel.length > 0 ? (
                    <>
                      <DescriptionContainerElement description="Barsortiments-Verfügbarkeit">
                        <span>
                          <b>Hinweis zur Lieferbarkeit und Bestellbarkeit</b>
                          <br />
                          Sollte ein Artikel bei den Barsortimenten Umbreit und
                          Libri als nicht lieferbar angezeigt werden, kann er
                          dennoch bestellbar sein. <br />
                          In diesem Fall ist der Titel zwar aktuell nicht über
                          Umbreit oder Libri verfügbar, jedoch über einen
                          anderen Lieferanten beziehbar und somit lieferbar in
                          der Ihnen angezeigten Lieferzeit.
                          <br />
                          <b>
                            Der angezeigte Bestand der Barsortimente ist rein
                            informativ.
                          </b>
                        </span>
                        <div className="ampelDivContainer">
                          <Ampel items={this.body.ampel} />
                        </div>
                      </DescriptionContainerElement>
                    </>
                  ) : null}
                  <br className="clearBoth" />
                </>
              ) : null}
            </div>
            <br className="clearBoth"></br>
            {this.body.recent_products != null &&
            this.body.recent_products.length > 0 ? (
              <div>
                <h3 className="border" style={{ marginBottom: '0px' }}>
                  Zuletzt angesehen
                </h3>
                <ProductCarousel
                  items={this.body.recent_products}
                  showTitle={true}
                ></ProductCarousel>
              </div>
            ) : null}
            {this.body.apd != null && this.body.apd.length > 0 ? (
              <div>
                <h3 className="border" style={{ marginBottom: '0px' }}>
                  Ähnliche Artikel
                </h3>
                <ProductCarousel items={this.body.apd}></ProductCarousel>
              </div>
            ) : null}

            <JSONLD_PD body={this.body}></JSONLD_PD>
            {hasConsent(ConsentEnum.FB_pixel) ? (
              <FB_pixel body={this.body}></FB_pixel>
            ) : null}
            {hasConsent(ConsentEnum.GoogleAnalytics) ? (
              <GoogleAnalytics></GoogleAnalytics>
            ) : null}
            {hasConsent(ConsentEnum.Webgains) ? (
              <WebgainsDetailsTag
                isBook={this.body.categorie == 'Buch'}
                productID={this.body.productsId}
                productPrice={this.body.productPrice}
                name={this.body.title}
              ></WebgainsDetailsTag>
            ) : null}
          </form>
        ) : (
          <div className="centerColumn" id="productInfoNoProduct">
            <div id="productInfoNoProductMainContent" className="content">
              Entschuldigen Sie bitte, aber der gewünschte Artikel konnte nicht
              gefunden werden.
            </div>
            <br />
            <br />

            <div className="buttonRow back">
              <a href={this.state.renderingDomain}>
                <span
                  className="cssButton normal_button button  button_continue"
                  onMouseOver={(e) => {
                    let target = e.target;
                    target.className =
                      'cssButtonHover normal_button button  button_continue button_continueHover';
                  }}
                  onMouseOut={(e) => {
                    let target = e.target;
                    target.className =
                      'cssButton normal_button button  button_continue';
                  }}
                >
                  &nbsp;Fortfahren&nbsp;
                </span>
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}
